<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-center">
        <v-btn @click="addCommentDialog = true">Add comment</v-btn>
        <v-dialog v-model="addCommentDialog" width="400px">
          <v-card>
            <v-toolbar flat color="secondary" dark>
              <v-toolbar-title>Add comment</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form :valid="addCommentValid" ref="addComment">
                <v-textarea v-model="model.comment" :rules="[rules.required]"></v-textarea>
                <v-btn @click="addComment()">Add</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <template v-if="comments.length > 0">
      <v-virtual-scroll height="450" :items="comments" :itemHeight="110">
        <template v-slot:default="{ item }">
          <v-app-bar color="rgba(0,0,0,0)" flat class="mb-8">
            <v-spacer v-if="item.user.id == currentUser.id"  />
            <v-card class="mt-10 mr-2" max-width="80%" :color="item.user.id == currentUser.id ? 'teal lighten-2':'white'" :dark="item.user.id == currentUser.id ">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="mb-4">
                    {{ item.comment }}
                  </div>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>{{item.updated_at | formatDate}}</span>
                    <span>{{item.user.username}}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-app-bar>
        </template>
      </v-virtual-scroll>
    </template>
    <v-row v-else>
      <v-col>No comment</v-col>
    </v-row>

  </v-container>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      comments: [],
      loading: false,
      addCommentDialog: false,
      addCommentValid: false,
      model: {
        comment: null
      },
      maxline:3
    };
  },
  computed: {
    ...mapGetters("auth", ["currentUser"]),
    rules: function() {
      return {
        required: value => !!value || "This field is mandatory."
      };
    }
  },
  props: {
    orderId: { type: Number }
  },
  mounted: function() {
    this.getComment();
  },
  filters:{
      formatDate (value) {
          if (!value) return '';
          return moment(value).format('DD/MM/YYYY');
      }
  },
  methods: {
    getComment() {
      this.loading = true;
      this.comments = [];
      this.$store
        .dispatch("orderComments/index", {
          orderId: this.orderId,
        })
        .then(({comments})=> {
          this.comments = comments
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addComment() {
      this.loading = true;
      if (this.$refs.addComment.validate()) {
        this.$store
          .dispatch("orderComments/create", {
            orderId: this.orderId,
            comment: this.model.comment
          })
          .finally(() => {
            this.model.comment = null;
            this.loading = false;
            this.addCommentDialog = false;
            this.getComment();
          });
      }
    }
  }
};
</script>

<style lang="less">
.comment{
  padding: 0 10px;
  &:after{
    content:"";
    display: block;
    width: 100%;
    border-bottom: 1px solid #d4d4d4;
    margin: 5px 0;
  }
  &:last-child{
    margin-bottom: 20px;
    &:after{
      display: none;
    }
  }
  .commentContent{
  }
  .commentInfo{
    font-style: italic;
    color:#d4d4d4;
  }
}
</style>
